import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { useFilterSearchParams } from "@/utils/hooksUtils";
import { useState } from "react";
import { DEFAULT_FILTER_CALC_BLACK_LISTS_QUERY_PARAMS } from "../api";
import { CalcBlacklistTable } from "../components/CalcBlacklistTable";
import { CalcBlacklistFilterForm } from "../components/forms/CalcBlacklistFilterForm";
import { CalcBlacklistForm } from "../components/forms/CalcBlacklistForm";
import type { CalcBlacklist, CalcBlacklistFilterPageRequest } from "../types";

export const CalcBlacklistContainer = () => {
  const [calcBlacklistFormOpen, setCalcBlacklistFormOpen] = useState(false);
  const [calcBlacklistToUpdate, setCalcBlacklistToUpdate] = useState<CalcBlacklist>();

  const searchParams = useFilterSearchParams<CalcBlacklistFilterPageRequest>({
    params: ["calcType", "institutionIds", "agentIds"],
    defaultQueryParamsObject: DEFAULT_FILTER_CALC_BLACK_LISTS_QUERY_PARAMS,
  });

  const handleCreateClick = () => {
    setCalcBlacklistFormOpen(true);
  };

  const handleUpdateClick = (calcBlacklist: CalcBlacklist) => {
    setCalcBlacklistFormOpen(true);
    setCalcBlacklistToUpdate(calcBlacklist);
  };

  const handleFormCancel = () => {
    setCalcBlacklistFormOpen(false);
    setCalcBlacklistToUpdate(undefined);
  };

  return (
    <ContentWrapper>
      <CalcBlacklistFilterForm searchParams={searchParams} onCreateClick={handleCreateClick} />

      <CalcBlacklistTable searchParams={searchParams} onUpdateClick={handleUpdateClick} />

      <CalcBlacklistForm
        calcBlacklist={calcBlacklistToUpdate}
        open={calcBlacklistFormOpen}
        onFormCancel={handleFormCancel}
      />
    </ContentWrapper>
  );
};
